<template>
  <div class="entrega99-cancel">
    <div class="s-card" style="margin: 5px 2px">
      <select v-model="selected" style="width: 100%; margin-top: 10px;">
        <option value="">Selecione...</option>
        <option v-for="m in motivos" :key="m.codigo" :value="m.codigo">
          {{ m.texto }}
        </option>
      </select>
    </div>
    <div id="footer" style="text-align: right">
      <button @click="$emit('cancel')">Cancelar</button>
      <button class="btn-primary" @click="confirmar">Confirmar</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "SEntrega99Cancel",
  props: {
    motivos: {
      type: Array,
      default: () => [
        {
          codigo: "410013",
          texto: "nenhum entregador aceitou o pedido por um longo período",
        },
        { codigo: "410014", texto: "informações do produto incorretas" },
        {
          codigo: "410015",
          texto: "método de pagamento selecionado incorretamente",
        },
        { codigo: "410016", texto: "endereço de entrega incorreto" },
        {
          codigo: "410017",
          texto: "informações de contato do destinatário incorretas",
        },
        { codigo: "410018", texto: "entrega não necessária" },
        { codigo: "410019", texto: "entregador não tem troco" },
        { codigo: "410020", texto: "entregador não coletou o item" },
        { codigo: "410021", texto: "não foi possível contatar o entregador" },
      ],
    },
  },
  data() {
    return {
      selected: "",
    };
  },
  methods: {
    confirmar() {
      if (!this.selected) {
        Notify.warning("Selecione o motivo do cancelamento.");
        return;
      }
      this.$emit("save", this.selected);
    },
  },
};
</script>

<style scoped>
.entrega99-cancel select {
  min-width: 200px;
}
</style>